export var ExternalProviderConvertStatusEnum;
(function (ExternalProviderConvertStatusEnum) {
    ExternalProviderConvertStatusEnum["DRAFT"] = "DRAFT";
    ExternalProviderConvertStatusEnum["INITIATED"] = "INITIATED";
})(ExternalProviderConvertStatusEnum || (ExternalProviderConvertStatusEnum = {}));
//# sourceMappingURL=external-provider-convert-status.enum.js.map